// services/settingService.js
import api from "./api";

export const getSetting = async () => {
  try {
    const response = await api.get('/settings');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const UpdateSetting = async (data) => {
  try {
    const response = await api.post('/settings', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const addHolidayDate = async (data) => {
  const response = await api.put('/settings/holidaydate', data);
  return response.data;
};

export const deleteHolidayDate = async (data) => {
  const response = await api.delete('/settings/holidaydate', { data });
  return response.data;
};

